const Available = () => {
  return (
    <div className="flex gap-2 items-center mx-8 py-2">
      <div className="w-4 h-4 bg-green-500 rounded-full"></div>
      <h4 className="text-sm">OPEN TO BUSINESS OPPORTUNITIES</h4>
    </div>
  );
};

export default Available;
